
import { compose, mdsWidget } from 'dojo/_base/declare';
import WidgetNavigationMap from '../../moreCore/UI/Navigation/WidgetNavigationMap';
import AdressFinderHome from './AddressFinderHome';
import AddressFinderLM from './AddressFinderLM';
import AddressCategoriesKanbanHub from '../AddressCategoriesKanban/AddressCategoriesKanbanHub';



/**
 * Home-Navigation für Orchesterdienste-Bereich
 */
class AddressesNavigation extends compose(WidgetNavigationMap<{}>) {

    //BASE
    postCreate(): void {

        this.layoutConfig["compact"].selectable = false;
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);


        this.setup({"AddressFinder": {
            navigationAreaName: "addresses",
            icon: "far fa-address-card",
            label: "AddressFinder__MainTitle",
            roles: ["AddressFinder", "Addresses_Read"],
            openByDefault: true,
            //featurepath: "OrchestraEmployment/SelfCheckin",
            targetWidget: AdressFinderHome

            },

            "AddressFinderLM": {
                navigationAreaName: "addresses",
                icon: "fas fa-history",
                label: "General_LastModified",
                roles: ["AddressFinder, Addresses_Read"],
                featurepath: "Address/AddressFinderLM",
                targetWidget: AddressFinderLM

            },


            "AddressCategoriesKanban": {
                navigationAreaName: "addresses",
                icon:"fas fa-table-columns",
                label: this.getTranslation("General_Kanban"),
                roles: ["AddressCategories_Kanban"],
                targetWidget: AddressCategoriesKanbanHub
            }
        }, {
            "addresses": {
                label: this.getTranslation("General_Label_Navigation")
            }
        });

    }
}

export default mdsWidget(AddressesNavigation);
